import { Routes } from '@angular/router';
export const Full_Content_Routes: Routes = [
    {
        path: 'dashboard',
        loadChildren: () => import('../../components/home/home.module').then(m => m.HomeModule)
    },
   {path:"info", loadChildren:()=>import("../../components/about/about.module").then(m=>m.AboutModule)},
    {
        path: 'video-stream',
        loadChildren: () => import('../../components/actionability/livewalk-test/video-streaming-test/video-streaming-test.module').then(m => {
            console.log(m);
            return m.VideoStreamingTestModule
        })
    },
    // {
    //     path: 'topology',
    //     loadChildren: () => import('../../components/top').then(m => m.TopologyModule)
    // },
    {
        path: 'topology',
        loadChildren: () => import('../../components/intelligence/topology-manager/topology-manager.module').then(m => m.TopologyManagerModule)
    },
    {
        path: 'assets',
        loadChildren: () => import('../../components/visibility/assets/assets.module').then(m => m.AssetsModule)
    },
    {
        path: 'devices-view',
        loadChildren: () => import('../../components/visibility/devices-view/devices-view.module').then(m => m.DevicesViewModule)
    },
    {
        path: 'walktest-report',
        loadChildren: () => import('../../components/visibility/walktest-report/walktest-report.module').then(m => m.WalktestReportModule)
    },
    {
        path: 'walktest-summary',
        loadChildren: () => import('../../components/visibility/walktest-summary/walktest-summary.module').then(m => m.WalktestSummaryModule)
    },
    {
        path: 'walktest-detailed-report',
        loadChildren: () => import('../../components/visibility/walktest-detailed/walktest-detailed.module').then(m => m.WalktestDetailedModule)
    },
    {
        path: 'statistics',
        loadChildren: () => import('../../components/visibility/statistics/statistics.module').then(m => m.StatisticsModule)
    },
    {
        path: 'kpidashboard',
        loadChildren: () => import('../../components/visibility/dashboard/dashboard.module').then(m => m.DashboardModule)
    },
    {
        path: 'telemetry',
        loadChildren: () => import('../../components/visibility/telemetry/telemetry.module').then(m => m.TelemetryModule)
    },
    {
        path: 'globalCompCharts',
        loadChildren: () => import('../../components/visibility/telemetry-two/telemetry-two.module').then(m => m.TelemetryTwoModule)
    },
    {
        path: 'devices',
        loadChildren: () => import('../../components/visibility/devices/devices.module').then(m => m.DevicesModule)
    },
    {
        path: 'sensors',
        loadChildren: () => import('../../components/visibility/sensors/sensors.module').then(m => m.SensorsModule)
    },
    {
        path: 'signal-heatmap',
        loadChildren: () => import('../../components/visibility/signal-heatmap/signal-heatmap.module').then(m => m.SignalHeatmapModule)
    },
    // {
    //     path: 'edge-rules-engine',
    //     loadChildren: () => import('../../components/visibility/edge-rules-engine/edge-rules-engine.module').then(m => m.EdgeRulesEngineModule)
    // },
    {
        path: 'edge-locate',
        loadChildren: () => import('../../components/visibility/edge-locate/edge-locate.module').then(m => m.EdgeLocateModule)
    },
    {
        path: 'edge-locate-new',
        loadChildren: () => import('../../components/visibility/edge-locate-new-ui/new-edge-locate.module').then(m => m.NewEdgeLocateModule)
    },
    
    {
        path: 'coverage-report',
        loadChildren: () => import('../../components/visibility/converage-report/converage-report.module').then(m => m.ConverageReportModule)
    },
    {
        path: 'cell-analysis',
        loadChildren: () => import('../../components/visibility/cell-analysis/cell-analysis.module').then(m => m.CellAnalysisModule)
    },
    {
        path: 'edge-geo-fencing-control',
        loadChildren: () => import('../../components/visibility/edgegeo-fencing/edgegeo-fencing.module').then(m => m.EdgegeoFencingModule)
    },
    {
        path: 'edge-intelligence',
        loadChildren: () => import('../../components/intelligence/edge-intelligence/edge-intelligence.module').then(m => m.EdgeIntelligenceModule)
    },
    {
        path: 'ml-models',
        loadChildren: () => import('../../components/intelligence/ml-models/ml-models.module').then(m => m.MlModelsModule)
    },
    {
        path: 'model-training',
        loadChildren: () => import('../../components/intelligence/model-training/model-training.module').then(m => m.ModelTrainingModule)
    },
    {
        path: 'topology-manager',
        loadChildren: () => import('../../components/intelligence/topology-manager/topology-manager.module').then(m => m.TopologyManagerModule)
    },
    {
        path: 'walktest-report-table',
        loadChildren: () => import('../../components/visibility/active-test-report/active-test-report-module').then(m => m.ActiveTestReportModule)
    },
    {
        path: 'data-model',
        loadChildren: () => import('../../components/intelligence/data-model/data-model.module').then(m => m.DataModelModule)
    },
    {
        path: 'test-reports',
        loadChildren: () => import('../../components/intelligence/test-reports/test-reports/test-reports.module').then(m => m.TestReportsModule)
    },
    {
        path: 'data-modeling',
        loadChildren: () => import('../../components/intelligence/data-modeling/data-modeling.module').then(m => m.DataModelingModule)
    },
    {
        path: 'edge-command-control',
        loadChildren: () => import('../../components/actionability/edgecommand-control/edgecommand-control.module').then(m => m.EdgecommandControlModule)
    },
    {
        path: 'edge-rules-engine',
        loadChildren: () => import('../../components/actionability/edgerules-engine/edgerules-engine.module').then(m => m.EdgerulesEngineModule)
    },
    {
        path: 'geo-fence',
        loadChildren: () => import('../../components/actionability/geo-fence/geo-fence.module').then(m => m.GeoFenceModule)
    },
    {
        path: 'live-walk-test',
        loadChildren: () => import('../../components/actionability/livewalk-test/livewalk-test.module').then(m => m.LivewalkTestModule)
    },
    {
        path: 'security-live-test',
        loadChildren: () => import('../../components/actionability/livewalk-test/livewalk-test.module').then(m => m.LivewalkTestModule)
    },
    {
        path: 'security-test-results',
        loadChildren: () => import('../../components/actionability/security-test-results/security-test-results.module').then(m => m.SecurityTestResultsModule)
    },
    {
        path: 'security-test-scheduler',
        loadChildren: () => import('../../components/actionability/security-test-scheduler/security-test-scheduler.module').then(m => m.SecurityTestSchedulerModule)
    },
    {
        path: 'api-gateway-control',
        loadChildren: () => import('../../components/administration/api-getway-control/api-getway-control.module').then(m => m.ApiGetwayControlModule)
    },
    {
        path: 'edge-management',
        loadChildren: () => import('../../components/administration/edge-management/edge-management.module').then(m => m.EdgeManagementModule)
    },
    {
        path: 'devices-setup',
        loadChildren: () => import('../../components/administration/setup-devices/setup-devices.module').then(m => m.SetupDevicesModule)
    },
    {
        path: 'admin',
        loadChildren: () => import('../../components/administration/admin/admin.module').then(m => m.AdminModule)
    },
    {
        path: 'cloud-management',
        loadChildren: () => import('../../components/administration/cloud-management/cloud-management.module').then(m => m.CloudManagementModule)
    },
    {
        path: 'mno-mapping',
        loadChildren: () => import('../../components/administration/mno-mapping/mno-mapping.module').then(m => m.MnoMappingModule)
    },
    {
        path: 'groups-manager',
        loadChildren: () => import('../../components/administration/groups-manager/groups-manager.module').then(m => m.GroupsManagerModule)
    },
    {
        path: 'users-manager',
        loadChildren: () => import('../../components/administration/users/users.module').then(m => m.UsersModule)
    },
    {
        path: 'floor-maps-manager',
        loadChildren: () => import('../../components/administration/floor-maps-manager/floor-maps-manager.module').then(m => m.FloorMapsManagerModule)
    },
    {
        path: 'device-upgrade-manager',
        loadChildren: () => import('../../components/administration/device-upgrade-manager/device-upgrade-manager.module').then(m => m.DeviceUpgradeManagerModule)
    },
    {
        path: 'diagnostic-tests',
        loadChildren: () => import('../../components/administration/diagnostic-test/diagnostic-test.module').then(m => m.DiagnosticTestModule)
    },

    {
        path: 'signalheatmap',
        loadChildren: () => import('../../components/visibility/signal-heatmap/signal-heatmap.module').then(m => m.SignalHeatmapModule)
    },
    {
        path: 'roles-manager',
        loadChildren: () => import('../../components/administration/role-manager/role-manager.module').then(m => m.RoleManagerModule)
    },
    {
        path: 'house-keeping',
        loadChildren: () => import('../../components/administration/data-rentention-policy/house-keeping.module').then(m => m.HouseKeepingModule)
    },
    {
        path: 'device-configuration',
        loadChildren: () => import('../../components/administration/device-configuration/device-configuration.module').then(m => m.DeviceConfigurationModule)
    },
    {
        path: 'global-configuration',
        loadChildren: () => import('../../components/administration/global-configurations/global-configurations.module').then(m => m.GlobalConfigurationsModule)
    },
    {
        path: 'global-notifications',
        loadChildren: () => import('../../components/administration/global-notifications/global-notifications.module').then(m => m.GlobalNotificationsModule)
    },
    {
        path: 'alaram-dashboard',
        loadChildren: () => import('../../components/administration/alaram-dashboard/alaram-dashboard.module').then(m => m.AlaramDashboardModule)
    },
    {
        path: 'help',
        loadChildren: () => import('../../components/administration/manual/manula.module').then(m => m.ManualModule)
    },
    {
        path: 'gps-report',
        loadChildren: () => import('../../components/visibility/gps-test-report/gps-test-report-module').then(m => m.GpsTestReportModule)
    },
    {
        path: 'deviceInventory',
        loadChildren: () => import('../../components/administration/device-inventory/device-inventory.module').then(m => m.DeviceInventoryModule)
    },
    {
        path: 'alarm-config',
        loadChildren: () => import('../../components/administration/alarm-config/alarm-config.module').then(m => m.AlarmConfigModule)
    },
    {
        path: 'wifi-logs',
        loadChildren: () => import('../../components/visibility/wifi-logs/wifi-logs.module').then(m =>m.WifiLogsModule)
    },
    {
        path: 'urc-logs',
        loadChildren: () => import('../../components/visibility/urc-logs/urc-logs.module').then(m => m.UrcLogsModule)
    },
    {
        path: 'baseline-approval',
        loadChildren: () => import('../../components/visibility/baseline-approval/baseline-approval.module').then(m => m.BaselineApprovalModule)
    },
    {
        path: 'transition-report',
        loadChildren: () => import('../../components/visibility/transition-report/transition-report.module').then(m => m.TransitionReportModule)
    },
    // {
    //     path: 'monitoring',
    //     loadChildren: () => import('../../components/monitoring/monitoring.module').then(m => m.MonitoringModule)
    // }, 
    // {
    //     path: 'insights',
    //     loadChildren: () => import('../../components/insights/insights.module').then(m => m.InsightsModule)
    // },
    // {
    //     path: 'kpiMaster',
    //     loadChildren: () => import('../../components/kpiMasterDashboard/kpiMasterDashboard.module').then(m => m.KPIMasterDashboardModule)
    // },
    // {
    //     path: 'tables',
    //     loadChildren: () => import('../../components/tables/tables.module').then(m => m.TablesModule)
    // },
    // {
    //     path: 'charts',
    //     loadChildren: () => import('../../components/charts/charts.module').then(m => m.ChartModule)
    // },
    // {
    //     path: 'pages',
    //     loadChildren: () => import('../../components/pages/pages.module').then(m => m.PagesModule)
    // },
    // {
    //     path: 'datamodel',
    //     loadChildren: () => import('../../components/data-model/data-model.module').then(m => m.DataModelModule)
    // },
    // {
    //     path: 'kpisRawdata',
    //     loadChildren: () => import('../../components/kpis-rawdata/kpis-rawdata.module').then(m => m.KpisRawdataModule)
    // },
    // {
    //     path: 'analytics',
    //     loadChildren: () => import('../../components/analitics/analitics.module').then(m => m.AnaliticsModule)
    // },
    // {
    //     path: 'config',
    //     loadChildren: () => import('../../components/config/config.module').then(m => m.ConfigModule)
    // },
    // {
    //     path: 'monitor',
    //     loadChildren: () => import('../../components/monitoring/monitoring.module').then(m => m.MonitoringModule)
    // },
    // {
    //     path: 'failures',
    //     loadChildren: () => import('../../components/insights/failures/failures.module').then(m => m.FailuresModule)
    // },
    // {
    //     path: 'devices',
    //     loadChildren: () => import('../../components/devices/devices.module').then(m => m.DevicesModule)
    // },
    // {
    //     path: 'kpidashboard',
    //     loadChildren: () => import('../../components/kpi-dashboard/kpi-dashboard.module').then(m => m.KpiDashboardModule)
    // },
    // {
    //     path: 'system',
    //     loadChildren: () => import('../../components/diagnostics-dashboard/diagnostics-dashboard.module').then(m => m.DiagnosticsDashboardModule)
    // },
    // {
    //     path: 'assets',
    //     loadChildren: () => import('../../components/assets-monitoring/assets-monitoring.module').then(m => m.AssetsMonitoringModule)
    // },
    // {
    //     path: 'edge',
    //     loadChildren: () => import('../../components/edge/edge.module').then(m => m.EdgeModule)
    // }

];